export default {
  getAdminGroupList: '/api/adminGroup/getAdminGroupList', // 用户组列表
  addAdminGroup: '/api/adminGroup/addAdminGroup', //添加用户组
  listGroupUsers: '/api/adminGroup/listGroupUsers', //获取用户组已选中用户列表
  editAdminGroup: '/api/adminGroup/editAdminGroup', //修改用户组信息
  delAdminGroup: '/api/adminGroup/delAdminGroup', //删除用户组

  getAdminList: '/api/admin/getAdminList', //用户列表
  editAdmin: '/api/admin/editAdmin', //修改用户信息
  // getRoleList: '/authorize/getRoleList', //获取角色列表
  addAdmin: '/api/admin/addAdmin', //添加用户
  // getAdminRole: '/admin/admin/getAdminRole', // 获取用户角色列表

  //员工列表
  getCompanyPersonnelList: '/api/companyPersonnel/getCompanyPersonnelList', //员工列表
  addCompanyPersonnel: '/api/companyPersonnel/addCompanyPersonnel', //新增员工
  editCompanyPersonnel: '/api/companyPersonnel/editCompanyPersonnel', //编辑员工
  delCompanyPersonnel: '/api/companyPersonnel/delCompanyPersonnel', //删除员工

  //修改个人信息
  editAdminSelf: '/api/admin/editAdminSelf',

  //移动公司员工
  moveCompanyPersonnel: '/api/companyPersonnel/moveCompanyPersonnel',

  //工种配置
  getWageCompanyList: '/api/wageCompany/getWageCompanyList',
  addWageCompany: '/api/wageCompany/addWageCompany',
  editWageCompany: '/api/wageCompany/editWageCompany',
  delWageCompany: '/api/wageCompany/delWageCompany',

  //请假管理
  getLeaveRequestsList: '/api/leaveRequests/getLeaveRequestsList',
  getSelfLeaveRequestsList: '/api/leaveRequests/getSelfLeaveRequestsList', //个人请假列表
  addLeaveRequests: '/api/leaveRequests/addLeaveRequests',
  approveLeaveRequests: '/api/leaveRequests/approveLeaveRequests', //审批请假
  cancelLeaveRequests: '/api/leaveRequests/cancelLeaveRequests', //取消请假

  //员工绑定账户
  getMyBankAccountsList: '/api/admin/getMyBankAccountsList',
  addMyBankAccounts: '/api/admin/addMyBankAccounts',
  editMyBankAccounts: '/api/admin/editMyBankAccounts',
  delMyBankAccounts: '/api/admin/delMyBankAccounts',
};
